import { render, staticRenderFns } from "./ItaijiImageResolver.vue?vue&type=template&id=232c7a32&scoped=true&"
import script from "./ItaijiImageResolver.vue?vue&type=script&lang=js&"
export * from "./ItaijiImageResolver.vue?vue&type=script&lang=js&"
import style0 from "./ItaijiImageResolver.vue?vue&type=style&index=0&id=232c7a32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "232c7a32",
  null
  
)

export default component.exports